import React from 'react';
import './icons.scss';

export const ArrowLeftAltIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M24,10.5H5.7l8.4-8.4L12,0L0,12l12,12l2.1-2.1l-8.4-8.4H24V10.5z"/>
    </svg>
);

export const ArrowLeftCircleIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M14.41,18.16a1,1,0,0,1-.68-0.29l-5.55-5a1.06,1.06,0,0,1,0-1.47l5.59-5.08A0.94,0.94,0,0,1,14.41,6a1,1,0,0,1,.68,1.64l-4.86,4.43,4.84,4.41a1,1,0,0,1,.3.69A1,1,0,0,1,14.41,18.16Z"/>
        <path d="M9.49,12l5.25-4.78a0.46,0.46,0,1,0-.65-0.65L8.51,11.63a0.56,0.56,0,0,0,0,.74l5.57,5.06a0.46,0.46,0,1,0,.65-0.65Z" />
        <path d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1.25A10.75,10.75,0,1,0,22.75,12,10.76,10.76,0,0,0,12,1.25Z"/>
    </svg>
);

export const ArrowLeftIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M7.4,12L18.7,1.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-12,10.9C5.1,11.4,5,11.7,5,12
            c0,0.3,0.1,0.6,0.3,0.8l12,10.9c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4L7.4,12z"/>
    </svg>
);

export const ArrowRightAltIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M0,13.5h18.3l-8.4,8.4L12,24l12-12L12,0L9.9,2.1l8.4,8.4H0L0,13.5z"/>
    </svg>
);

export const BasketIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M6,9.8c-0.1,0-0.2,0-0.2,0c-0.4-0.1-0.6-0.6-0.5-1l2.1-6.8c0.1-0.4,0.6-0.6,1-0.5c0.4,0.1,0.6,0.6,0.5,1L6.8,9.3
            C6.6,9.6,6.3,9.8,6,9.8z"/>
        <path d="M18,9.8c-0.3,0-0.6-0.2-0.7-0.5l-2.1-6.8c-0.1-0.4,0.1-0.8,0.5-1c0.4-0.1,0.8,0.1,1,0.5l2.1,6.8c0.1,0.4-0.1,0.8-0.5,1
            C18.1,9.8,18.1,9.8,18,9.8z"/>
        <path d="M20.2,22.5H3.8c-0.4,0-0.7-0.2-0.8-0.6L0,9.5C0,9.2,0,9,0.2,8.8c0.1-0.2,0.4-0.3,0.6-0.3h22.5c0.2,0,0.5,0.1,0.6,0.3
            C24,9,24,9.2,24,9.5l-3,12.4C20.9,22.2,20.6,22.5,20.2,22.5z M4.4,20.9h15.2l2.6-10.8H1.8L4.4,20.9z"/>
    </svg>
);

export const CaretDownIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M23.6,5.8c-0.5-0.5-1.4-0.5-1.9,0L12,15.5L2.3,5.8c-0.5-0.5-1.4-0.5-1.9,0c-0.5,0.5-0.5,1.4,0,1.9l10.4,10.4
            c0.3,0.3,0.8,0.4,1.2,0.4c0.4,0.1,0.9,0,1.2-0.4L23.6,7.8C24.1,7.2,24.1,6.4,23.6,5.8z"/>
    </svg>
);

export const CheckmarkCircleIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z M12,1.5C6.2,1.5,1.5,6.2,1.5,12S6.2,22.5,12,22.5
            S22.5,17.8,22.5,12S17.8,1.5,12,1.5z"/>
        <path d="M10.6,16.6c-0.2,0-0.4-0.1-0.5-0.2l-4.4-4.4c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l3.8,3.8l6.7-7.2
            c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1l-7.2,7.7C11,16.6,10.8,16.6,10.6,16.6C10.6,16.6,10.6,16.6,10.6,16.6z"/>
    </svg>
);

export const ChevronDownIcon = () => (
    <svg viewBox="0 0 20 20" className="cpd-icon">
        <path d="M16,6c-0.28,0-0.53,0.11-0.71,0.29L10,11.59L4.71,6.29C4.53,6.11,4.28,6,4,6
            C3.45,6,3,6.45,3,7c0,0.28,0.11,0.53,0.29,0.71l6,6C9.47,13.89,9.72,14,10,14s0.53-0.11,0.71-0.29l6-6C16.89,7.53,17,7.28,17,7
            C17,6.45,16.55,6,16,6z"/>
    </svg>
);

export const CloseCircleIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M14.6,8.3l-2.7,2.7L9.3,8.3C9,8,8.5,8,8.2,8.3c-0.3,0.3-0.4,0.8,0,1.1l2.7,2.7l-2.5,2.5C8,15,8,15.5,8.3,15.8
            c0.3,0.3,0.8,0.4,1.1,0l2.7-2.7l2.7,2.7c0.3,0.3,0.8,0.4,1.1,0c0.3-0.3,0.4-0.8,0-1.1L13.3,12L16,9.3c0.3-0.3,0.4-0.8,0-1.1
            C15.4,8,14.9,8,14.6,8.3z M3.5,3.5c-4.7,4.7-4.7,12.3,0,17s12.3,4.7,17,0s4.7-12.3,0-17S8.2-1.2,3.5,3.5z M19.4,19.4
            c-4.1,4.1-10.7,4.1-14.8,0S0.5,8.7,4.6,4.6s10.7-4.1,14.8,0S23.5,15.3,19.4,19.4z"/>
    </svg>
);

export const CloseIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M14.8,12l8.6-8.6c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0L12,9.2L3.4,0.6c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8
            L9.2,12l-8.6,8.6c-0.8,0.8-0.8,2,0,2.8C1,23.8,1.5,24,2,24s1-0.2,1.4-0.6l8.6-8.6l8.6,8.6C21,23.8,21.5,24,22,24s1-0.2,1.4-0.6
            c0.8-0.8,0.8-2,0-2.8L14.8,12z"/>
    </svg>
);

export const ExperiencesIcon = () => (
    <svg viewBox="0 0 80 80" className="cpd-icon">
        <path d="M78.4,1.7L1.6,24.9l41,9.6l0,0L45,35l10.1,43.3L78.4,1.7z M64,35.3l-13.4-3.1l20.5-20.5L64,35.3z
             M17.1,24.4L68.3,8.9L46,31.2L17.1,24.4z M62.8,39.2l-7.2,23.7L49.3,36L62.8,39.2z"/>
    </svg>
);

export const EyeClosedIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M20.6,6.8l-0.9,1.1c1.9,1.5,2.9,3.6,2.9,4.1c0,1.3-3.4,6.7-10.6,6.7c-1.1,0-2.5-0.2-3.4-0.4l-0.3,1.4
            c0.9,0.2,2.5,0.4,3.6,0.4c7.8,0,12-5.8,12-8.1C24,10.8,22.6,8.4,20.6,6.8z"/>
        <path d="M21.6,1.4L18,5c-1.4-0.8-4-1.1-6-1.1C4.2,3.9,0,9.6,0,12c0,1.2,1.6,4.3,4.6,6.4l-3.3,3.3l1,1L22.6,2.4L21.6,1.4z M1.4,12
            c0-1.3,3.4-6.7,10.6-6.7c1.6,0,3.7,0.3,4.9,0.8L15,8c-0.9-0.6-1.9-1-3-1c-2.8,0-5,2.2-5,5c0,1.1,0.4,2.1,1,3l-2.3,2.3
            C2.7,15.5,1.4,12.6,1.4,12z M8.4,12c0-2,1.6-3.6,3.6-3.6c0.7,0,1.4,0.2,2,0.6l-5,5C8.6,13.4,8.4,12.7,8.4,12z"/>
        <path d="M12,15.6c-0.2,0-0.3,0-0.5,0l-0.2,1.4c0.2,0,0.4,0,0.7,0c2.8,0,5-2.2,5-5c0-0.2,0-0.4,0-0.7l-1.4,0.2c0,0.2,0,0.3,0,0.5
            C15.6,14,14,15.6,12,15.6z"/>
    </svg>
);

export const EyeOpenIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M12,3.9C4.2,3.9,0,9.6,0,12s4.2,8.1,12,8.1s12-5.8,12-8.1S19.8,3.9,12,3.9z M12,18.7c-7.2,0-10.6-5.4-10.6-6.7
            S4.8,5.3,12,5.3s10.6,5.4,10.6,6.7S19.2,18.7,12,18.7z"/>
        <path d="M12,7c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S14.8,7,12,7z M12,15.6c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6
            c2,0,3.6,1.6,3.6,3.6C15.6,14,14,15.6,12,15.6z"/>
    </svg>
);

export const LogoutIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M23,24H9.6c-0.5,0-1-0.4-1-1v-7.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v7.2h13V1.2h-13v7.4
            c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6V1c0-0.5,0.4-1,1-1H23c0.5,0,1,0.4,1,1v22C24,23.6,23.6,24,23,24z"/>
        <path d="M17.7,12.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2l-4.7-4.7
            c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l3.7,3.7H0.6C0.3,11.4,0,11.7,0,12c0,0.3,0.3,0.6,0.6,0.6h15.1L12,16.3
            c-0.2,0.2-0.2,0.6,0,0.8c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l4.7-4.7C17.6,12.4,17.6,12.3,17.7,12.2
            C17.7,12.2,17.7,12.2,17.7,12.2z"/>
    </svg>
);

export const MerchandiseIcon = () => (
    <svg viewBox="0 0 80 80" className="cpd-icon">
        <path d="M75.4,4.6H42.5L4.6,42.5l32.9,32.9l38-37.9L75.4,4.6L75.4,4.6z M35.9,68.1L12.2,44.5H38L35.9,68.1z M38.3,40.5
            H12.2l28.6-28.6L38.3,40.5z M40,67.3l5.2-58.7h26.2v27.2L40,67.3z"/>
        <path d="M64.4,12.1c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3S66.1,12.1,64.4,12.1z"/>
    </svg>
);

export const PlaneIcon = () => (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M6.62,23.15l-0.15,0a0.75,0.75,0,0,1-.55-0.46L4.49,19.09a0.75,0.75,0,1,1,1.39-.56l1,2.53,0.37-.37L7,18.19a0.75,0.75,0,0,1,.24-0.64l4.66-4.3a0.75,0.75,0,0,1,1.2.26l3.16,7.57,0.74-.74-1.38-10a0.75,0.75,0,0,1,.24-0.66l4.76-4.33a0.75,0.75,0,0,1,1,1.11L17.1,10.5l1.38,10a0.75,0.75,0,0,1-.21.63l-1.79,1.79a0.75,0.75,0,0,1-1.22-.24l-3.17-7.62L8.49,18.39,8.8,20.87a0.75,0.75,0,0,1-.21.62L7.15,22.93A0.75,0.75,0,0,1,6.62,23.15Z" transform="translate(-0.85 -0.85)" />
        <path d="M5.19,19.56a0.73,0.73,0,0,1-.27-0.05L1.33,18.13a0.75,0.75,0,0,1-.27-1.22L2.5,15.42a0.75,0.75,0,0,1,.64-0.22l2.12,0.3L8.9,11.59,1.34,8.76a0.75,0.75,0,0,1-.27-1.23L2.86,5.73a0.76,0.76,0,0,1,.63-0.21l10,1.38,4.06-4.47A4.63,4.63,0,0,1,20.84.85h0a2.57,2.57,0,0,1,1.73.58,2.62,2.62,0,0,1,.57,1.88,4.69,4.69,0,0,1-1.56,3.1,0.75,0.75,0,0,1-1.06-1.06c1.67-1.67,1-2.84,1-2.89h0s-1.19-.65-2.84,1L14.35,8.2a0.76,0.76,0,0,1-.66.24l-10-1.38L3,7.76l7.52,2.82a0.75,0.75,0,0,1,.29,1.21l-4.66,5a0.75,0.75,0,0,1-.66.23l-2.13-.3-0.38.39,2.53,1A0.75,0.75,0,0,1,5.19,19.56Z" transform="translate(-0.85 -0.85)" />
    </svg>
);
